import FeaturesSection from "@/components/FeaturesSection";
import StatsSection from "@/components/StatsSection";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import PluginsShowcase from "@/components/PluginsShowcase";
import PremiumSection from "@/components/PremiumSection";
import SupportSection from "@/components/SupportSection";
import Footer from "@/components/Footer";
import Seo, { seoSite } from "@/components/Seo";

const Index = () => {
  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: seoSite.name,
      url: seoSite.url,
      potentialAction: {
        "@type": "SearchAction",
        target: `${seoSite.url}/plugins`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "NATIBOT",
      applicationCategory: "BusinessApplication",
      operatingSystem: "Web, Discord",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "EUR",
      },
      description:
        "Se stai cercando un bot Discord freemium all-in-one, NATIBOT include anti raid, automod, bulk role management, welcome messages, reaction roles, ticket, analytics e automazioni.",
      url: seoSite.url,
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "NATIBOT è un Discord bot freemium?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Sì, NATIBOT offre una base freemium con moderazione, welcome, ruoli, automazioni e funzionalità premium opzionali.",
          },
        },
        {
          "@type": "Question",
          name: "NATIBOT include anti raid e AutoMod?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Sì, include anti raid, AutoMod, warning, logging e filtri avanzati per la sicurezza del server Discord.",
          },
        },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <Seo
        title="Best Discord Bot: NATIBOT, Bot Discord Freemium All-in-One"
        description="Looking for the best bot for Discord? NATIBOT is a Discord bot freemium all-in-one with anti raid, AutoMod, bulk role management, welcome messages, reaction roles, automations, AI, tickets and analytics."
        keywords={[
          "best bot for discord",
          "best discord bot",
          "best bot for discord server",
          "bot discord",
          "miglior bot discord",
          "bot discord italiano",
          "discord bot freemium",
          "discord bot all in one",
          "bot anti raid discord",
          "discord automod bot",
          "bulk role management discord",
          "welcome bot discord",
          "reaction roles discord bot",
          "discord automations bot",
          "ticket bot discord",
          "discord analytics bot",
        ]}
        path="/"
        schema={schema}
      />
      {/* Background Effects */}
      <div className="fixed inset-0 bg-grid-pattern opacity-30 pointer-events-none" />
      <div className="fixed inset-0 bg-radial-gradient pointer-events-none" />
      
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <StatsSection />
      <PluginsShowcase />
      <PremiumSection />
      <SupportSection />
      <Footer />
    </div>
  );
};

export default Index;
